import i18n from "i18next";

import {
  AgriculturePolicyDetails,
  HazardIdEnum,
  LocationRiskAssessment,
  PolicyDetails,
} from "../hazardIdEnum";
import { PermissionIdEnum } from "../../util/types/permissions/permissionIdEnum";

const windColorRange = ["#f9f9f9", "#fff5f0", "#fca486", "#ea372a", "#67000d"];

export const getWindHazardsList = (): Hazard[] => [
  {
    cysId: HazardIdEnum.HighWindItaSevere,
    name: "High Wind Severe",
    // permissions: ["CYS_RISK_WINDSTORM_EUR_EURAIN_SEVERE_C"],
    permissions: [PermissionIdEnum.HighWindItaSevere],
    colorRange: windColorRange,
    description: i18n.t("riskExposureMapExplained.windSevere"),
    label: `${i18n.t("riskAssessment.highWind")} (ITA) - ${i18n.t("riskAssessment.severe")}`,
    pages: [PolicyDetails, AgriculturePolicyDetails, LocationRiskAssessment],
  },
  {
    cysId: HazardIdEnum.HighWindItaSevereRcp45,
    name: "High Wind Severe Rcp 4.5",
    // permissions: ["CYS_RISK_WINDSTORM_ITA_EURAIN_SEVERE_P20212050_RCP45"],
    permissions: [PermissionIdEnum.HighWindItaSevereRcp45],
    colorRange: windColorRange,
    description: i18n.t("riskExposureMapExplained.windSevereRcp", { rcpValue: 4.5 }),
    label: `${i18n.t("riskAssessment.highWind")} (ITA) - ${i18n.t("riskAssessment.severe")} - RCP4.5`,
    pages: [PolicyDetails, LocationRiskAssessment],
  },
  {
    cysId: HazardIdEnum.HighWindItaSevereRcp85,
    name: "High Wind Severe Rcp 8.5",
    // permissions: ["CYS_RISK_WINDSTORM_EUR_EURAIN_SEVERE_RCP85_P2021-2050"],
    permissions: [PermissionIdEnum.HighWindItaSevereRcp85],
    colorRange: windColorRange,
    description: i18n.t("riskExposureMapExplained.windSevereRcp", { rcpValue: 8.5 }),
    label: `${i18n.t("riskAssessment.highWind")} (ITA) - ${i18n.t("riskAssessment.severe")} - RCP8.5`,
    pages: [PolicyDetails, LocationRiskAssessment],
  },
  {
    cysId: HazardIdEnum.HighWindItaExtreme,
    name: "High Wind Extreme",
    // permissions: ["CYS_RISK_WINDSTORM_EUR_EURAIN_EXSEVERE_C"],
    permissions: [PermissionIdEnum.HighWindItaExtreme],
    colorRange: windColorRange,
    description: i18n.t("riskExposureMapExplained.windExtreme"),
    label: `${i18n.t("riskAssessment.highWind")} (ITA) - ${i18n.t("riskAssessment.extreme")}`,
    pages: [PolicyDetails, AgriculturePolicyDetails, LocationRiskAssessment],
  },
  {
    cysId: HazardIdEnum.HighWindItaExtremeRcp45,
    name: "High Wind Extreme Rcp 4.5",
    // permissions: ["CYS_RISK_WINDSTORM_EUR_EURAIN_EXSEVERE_RCP45_P2021-2050"],
    permissions: [PermissionIdEnum.HighWindItaExtremeRcp45],
    colorRange: windColorRange,
    description: i18n.t("riskExposureMapExplained.windExtremeRcp", { rcpValue: 4.5 }),
    label: `${i18n.t("riskAssessment.highWind")} (ITA) - ${i18n.t("riskAssessment.extreme")} - RCP4.5`,
    pages: [PolicyDetails, LocationRiskAssessment],
  },
  {
    cysId: HazardIdEnum.HighWindItaExtremeRcp85,
    name: "High Wind Extreme Rcp 8.5",
    // permissions: ["CYS_RISK_WINDSTORM_EUR_EURAIN_EXSEVERE_RCP85_P2021-2050"],
    permissions: [PermissionIdEnum.HighWindItaExtremeRcp85],
    colorRange: windColorRange,
    description: i18n.t("riskExposureMapExplained.windExtremeRcp", { rcpValue: 8.5 }),
    label: `${i18n.t("riskAssessment.highWind")} (ITA) - ${i18n.t("riskAssessment.extreme")} - RCP8.5`,
    pages: [PolicyDetails, LocationRiskAssessment],
  },
];
